import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import type { WorkArrangements } from '@talentmesh/utils';
import { Info } from 'lucide-react';
import { useWatch } from 'react-hook-form';
import { JobDetailsFieldTypes } from '../../JobDetailsStepUtils';
import JobLocationTooltipBody from './JobLocationTooltipBody';
import UIStrings from '@/Utils/UIStrings';

function JobLocationLabel() {
    const workArrangement: WorkArrangements = useWatch({ name: JobDetailsFieldTypes.WorkArrangement });

    const title = workArrangement === 'Remote' ? `${UIStrings.EmployeeLocation}*` : `${UIStrings.JobLocation}*`;

    return (
        <div className="flex flex-row items-center gap-2">
            <span className="text-foreground text-sm leading-none font-medium">{title}</span>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Info className="text-muted-foreground size-3.5 cursor-pointer" />
                    </TooltipTrigger>
                    <TooltipContent
                        side="bottom"
                        sideOffset={16}
                        hideArrow
                        className="bg-card text-foreground max-w-sm p-4 drop-shadow"
                    >
                        <JobLocationTooltipBody />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export default JobLocationLabel;
